var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRdeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 55,
    viewBox: "0 0 125 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.50253 50.4356C2.1083 50.4356 1.9066 50.5639 1.9066 50.8161V52.6772C1.9066 52.9385 2.1083 53.0668 2.50253 53.0668H6.01389V54.0111H1.86076C0.774348 54.0111 -0.00952148 53.7132 -0.00952148 53.1356V50.4081C-0.00952148 49.8305 0.774348 49.4867 1.86076 49.4867H6.00931V50.431H2.49794L2.50253 50.4356Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.91248 54.0114L9.37868 50.0508C9.67206 49.5878 10.2313 49.4365 10.8272 49.4365C11.4232 49.4365 12.0283 49.5878 12.3079 50.0508L14.6962 54.0114H12.6884L12.1841 53.2321H9.42452L8.92028 54.0114H6.91248ZM10.7997 50.9263L9.96086 52.2832H11.6432L10.8043 50.9263H10.7997Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6903 51.3572C22.6903 51.4626 22.6674 51.7468 22.6582 51.8385C22.5803 52.3473 21.8194 52.5994 20.82 52.5994H17.8496V54.0159H15.9335V49.4915H20.82C21.9065 49.4915 22.6903 49.8353 22.6903 50.4128V51.3572ZM17.845 50.4358V51.6551H20.1645C20.5588 51.6551 20.7696 51.5268 20.7696 51.2655V50.8208C20.7696 50.5641 20.5588 50.4403 20.1645 50.4403H17.845V50.4358Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.289 54.0113H24.3729V49.4868H26.289V54.0113Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5928 50.4358V54.0113H29.6767V50.4358H27.5222V49.4915H33.6877V50.4358H31.5928Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0181 54.0114L35.4843 50.0508C35.7777 49.5878 36.3369 49.4365 36.9328 49.4365C37.5287 49.4365 38.1338 49.5878 38.4135 50.0508L40.8017 54.0114H38.7939L38.2897 53.2321H35.5301L35.0259 54.0114H33.0181ZM36.9099 50.9263L36.071 52.2832H37.7534L36.9145 50.9263H36.9099Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8701 53.1357V49.4868H43.7862V52.6773C43.7862 52.9386 43.9879 53.0669 44.3822 53.0669H47.8798V54.0113H43.7404C42.654 54.0113 41.8701 53.7133 41.8701 53.1357Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M59.867 53.1357C59.867 53.7133 59.0832 54.0113 57.9967 54.0113H55.0263C53.9261 54.0113 53.156 53.7225 53.156 53.1357V50.4082C53.156 49.8306 53.9399 49.4868 55.0263 49.4868H59.3765V50.4311H55.6635C55.2692 50.4311 55.0675 50.5595 55.0675 50.8116V52.6727C55.0675 52.9294 55.2601 53.0624 55.6405 53.0624H57.3458C57.74 53.0624 57.9417 52.934 57.9417 52.6727V51.5863H59.8716V53.1265L59.867 53.1357Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8049 52.2647C63.7361 52.2234 63.6811 52.1822 63.6352 52.1409V54.0066H61.7191V49.4822H66.6515C67.7379 49.4822 68.5218 49.826 68.5218 50.4036V51.3295C68.5218 52.008 68.1734 52.3793 66.2665 52.3793H66.2115L68.8244 54.002H66.5278L63.8049 52.2555V52.2647ZM63.6352 51.5771C63.814 51.4854 64.0936 51.4396 64.3733 51.4396H66.0098C66.404 51.4396 66.6057 51.3112 66.6057 51.0591V50.8207C66.6057 50.564 66.404 50.4402 66.0098 50.4402H63.6307V51.5817L63.6352 51.5771Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1394 53.1358C77.1394 53.7133 76.3556 54.0113 75.2692 54.0113H72.2437C71.1573 54.0113 70.3734 53.6675 70.3734 53.0899V50.4128C70.3734 49.8353 71.1573 49.4915 72.2437 49.4915H75.2692C76.3556 49.4915 77.1394 49.8353 77.1394 50.4128V53.1403V53.1358ZM72.285 52.6774C72.285 52.9386 72.4867 53.067 72.968 53.067H74.6274C75.0216 53.067 75.2233 52.9386 75.2233 52.6774V50.8162C75.2233 50.5595 75.0216 50.4358 74.6274 50.4358H72.968C72.4867 50.4358 72.285 50.5641 72.285 50.8162V52.6774Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9076 52.7277C80.9076 52.9248 81.1001 53.0624 81.6044 53.0624H83.1858C83.6993 53.0624 83.8826 52.9248 83.8826 52.7277V49.4868H85.7987V53.0165C85.7987 53.5666 85.2807 54.0067 84.1393 54.0067H80.7288C79.5874 54.0067 78.9915 53.5666 78.9915 53.0165V49.4868H80.9076V52.7277Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5222 51.3572C94.5222 51.4626 94.4993 51.7468 94.4902 51.8385C94.4122 52.3473 93.6513 52.5994 92.652 52.5994H89.6815V54.0159H87.7654V49.4915H92.6565C93.743 49.4915 94.5268 49.8353 94.5268 50.4128V51.3572H94.5222ZM89.6769 50.4358V51.6551H91.9964C92.3907 51.6551 92.6015 51.5268 92.6015 51.2655V50.8208C92.6015 50.5641 92.3907 50.4403 91.9964 50.4403H89.6769V50.4358Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1257 53.7453C98.1257 53.8232 98.1027 53.8966 98.0477 53.9424L97.2501 54.6025H96.2279L96.9109 54.0112H96.778C96.3837 54.0112 96.205 53.9378 96.205 53.7453V53.3098C96.205 53.1173 96.4296 53.0439 96.778 53.0439H97.6306C97.9331 53.0439 98.1257 53.1127 98.1257 53.3098V53.7453Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M103.677 53.1357V49.4868H105.593V52.6773C105.593 52.9386 105.794 53.0669 106.189 53.0669H109.686V54.0113H105.547C104.46 54.0113 103.677 53.7133 103.677 53.1357Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M110.865 53.1357V49.4868H112.781V52.6773C112.781 52.9386 112.982 53.0669 113.377 53.0669H116.874V54.0113H112.735C111.648 54.0113 110.865 53.7133 110.865 53.1357Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M120.509 50.4357C120.115 50.4357 119.913 50.5641 119.913 50.8162V52.6773C119.913 52.9386 120.115 53.0669 120.509 53.0669H124.021V54.0113H119.872C118.786 54.0113 118.002 53.7133 118.002 53.1357V50.4082C118.002 49.8306 118.786 49.4868 119.872 49.4868H124.021V50.4311H120.509V50.4357Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1803 38.8797C10.919 38.7238 10.699 38.5634 10.5248 38.4075V45.6732H3.04822V28.0706H22.2782C26.5184 28.0706 29.576 29.3999 29.576 31.6599V35.2721C29.576 37.9125 28.2191 39.3564 20.7884 39.3564H20.5684L30.7541 45.6732H21.7923L11.1711 38.8797H11.1803ZM10.5248 36.1935C11.2261 35.8313 12.3171 35.6525 13.4081 35.6525H19.7891C21.3202 35.6525 22.104 35.1575 22.104 34.1627V33.2368C22.104 32.242 21.3156 31.7469 19.7891 31.7469H10.5248V36.1935Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6925 28.0707H53.0555C57.2957 28.0707 60.3532 29.4 60.3532 31.66V42.2674C60.3532 44.5228 57.2957 45.6734 53.0555 45.6734H33.6925V28.0707ZM41.1645 31.7517V41.997H50.5617C52.0928 41.997 52.8767 41.5019 52.8767 40.4842V33.2415C52.8767 32.2467 52.0882 31.7517 50.5617 31.7517H41.1645Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M71.327 38.701V40.4842C71.327 41.4973 72.1155 41.997 73.642 41.997H87.1465V45.6734H71.1482C66.908 45.6734 63.8505 44.5228 63.8505 42.2674V31.66C63.8505 29.4046 66.908 28.0707 71.1482 28.0707H87.1465V31.7471H73.642C72.1109 31.7471 71.327 32.2421 71.327 33.2369V35.0201H86.711V38.6965H71.327V38.701Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3414 30.8622L89.9519 32.0999V37.5961L97.3414 36.3539V30.8622Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3414 6.56689L89.9519 7.80458V13.3008L97.3414 12.0586V6.56689Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M105.405 33.0442L97.8 30.8943V36.3768L105.405 38.5267V33.0442Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3414 24.9028L89.9519 26.1405V31.6368L97.3414 30.3945V24.9028Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8 24.9349V30.4174L105.405 32.5673V27.0848L97.8 24.9349Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3414 12.526L89.9519 13.7637V19.7183L97.3414 18.4761V12.526Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3414 18.9436L89.9519 20.1813V25.6775L97.3414 24.4353V18.9436Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3414 36.8214L89.9519 38.0591V45.6732H97.3414V36.8214Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8 6.12218L105.405 8.2721V2.97754L97.8 0.745117V6.12218Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3415 6.09906V0.625732L89.952 2.01469V7.34134L97.3415 6.09906Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8 18.9758V24.4583L105.405 26.6082V21.1257L97.8 18.9758Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8 36.8536V45.6733H105.405V39.0035L97.8 36.8536Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8 12.5582V18.4991L105.405 20.649V14.7081L97.8 12.5582Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8 6.59888V12.0814L105.405 14.2313V8.74879L97.8 6.59888Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M113.569 27.6623V22.9957L107.724 24.0455V28.7074L113.569 27.6623Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M113.569 28.1252L107.724 29.175V33.8369L113.569 32.7872V28.1252Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M120.046 29.9818L114.027 28.162V32.8102L120.046 34.6301V29.9818Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M113.569 17.4767L107.724 18.5218V23.578L113.569 22.5329V17.4767Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M113.569 38.3798L107.724 39.4295V45.9022H113.569V38.3798Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M114.027 23.0325V27.6807L120.046 29.5005V24.8523L114.027 23.0325Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M114.027 11.9024L120.046 13.7222V9.25739L114.027 7.36877V11.9024Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M113.569 33.2549L107.724 34.3046V38.9666L113.569 37.9168V33.2549Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M113.569 17.009V12.347L107.724 13.3968V18.0587L113.569 17.009Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M114.027 38.4164V45.9021H120.046V40.2362L114.027 38.4164Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M114.027 17.5088V22.5512L120.046 24.3711V19.3286L114.027 17.5088Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M114.027 33.287V37.9398L120.046 39.7551V35.1068L114.027 33.287Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M114.027 12.3792V17.0319L120.046 18.8472V14.199L114.027 12.3792Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M113.569 11.8797V7.26355L107.724 8.43706V12.9294L113.569 11.8797Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M124.021 47.1033H-0.00952148V47.5617H124.021V47.1033Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRdeLogo);
export default __webpack_public_path__ + "static/media/rde-logo.d58853aeab8145502d4e087844922722.svg";
export { ForwardRef as ReactComponent };